module.exports = __webpack_public_path__ + "static/media/cementTruck_tomato.32ae59fa.svg";